export default __webpack_public_path__ + "static/media/location_preview_river_of_ruin.49ff04de.svg";